import { Link } from "react-router-dom";
import { contact } from "../data/contact";
import { Mail, MessageCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function Footer() {
  const { t, dir, lang } = useLanguage();
  return (
    <footer
      dir={dir}
      lang={lang}
      className="relative mt-32 border-t border-white/10 bg-black"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-3">
            <span className="font-display text-3xl font-black gradient-gold-text leading-none">
              SS
            </span>
            <span className="flex flex-col leading-tight">
              <span className="text-[10px] uppercase tracking-[0.25em] text-white/50">
                Salama
              </span>
              <span className="text-[11px] uppercase tracking-[0.3em] text-white/80">
                Solutions
              </span>
            </span>
          </Link>
          <p className="mt-6 max-w-md text-white/60 text-sm leading-relaxed">
            {t.footer.tagline}
          </p>

          <div className="mt-8 flex flex-col gap-3 text-sm">
            <a
              href={`mailto:${contact.email}`}
              className="inline-flex items-center gap-3 text-white/80 hover:text-agency-gold transition-colors w-fit"
              data-testid="footer-email-link"
            >
              <Mail size={16} className="text-agency-gold" /> <span dir="ltr">{contact.email}</span>
            </a>
            <a
              href={contact.whatsappUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-3 text-white/80 hover:text-agency-gold transition-colors w-fit"
              data-testid="footer-whatsapp-link"
            >
              <MessageCircle size={16} className="text-agency-gold" /> <span dir="ltr">{contact.whatsappDisplay}</span>
            </a>
          </div>

          <p
            className="mt-6 text-[11px] text-white/30 max-w-md leading-relaxed"
            data-testid="footer-business-credibility"
          >
            {t.footer.credibility}
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-white/50">{t.footer.studio}</h4>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li><Link to="/about" className="hover:text-agency-gold">{t.nav.about}</Link></li>
            <li><Link to="/services" className="hover:text-agency-gold">{t.nav.services}</Link></li>
            <li><Link to="/pricing" className="hover:text-agency-gold">{t.nav.pricing}</Link></li>
            <li><Link to="/demos" className="hover:text-agency-gold">{t.nav.demos}</Link></li>
            <li><Link to="/contact" className="hover:text-agency-gold">{t.nav.contact}</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-agency-gold">{t.footer.privacyPolicy}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-white/50">{t.footer.demos}</h4>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li><Link to="/demo/restaurant" className="hover:text-agency-gold">Olive Flame Restaurant</Link></li>
            <li><Link to="/demo/cafe" className="hover:text-agency-gold">Velvet Cup Café</Link></li>
            <li><Link to="/demo/clinic" className="hover:text-agency-gold">CarePoint Clinic</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Salama Solutions. {t.footer.rights}</p>
          <p className="font-mono-tech">{t.footer.builtNote}</p>
        </div>
      </div>
    </footer>
  );
}
